module.exports = __webpack_public_path__ + "static/media/spaceship-image.4c74fe29.png";